import {PNOA_YEARS} from '@/config';

const PNOA_HISTORICO_SOURCES = PNOA_YEARS.reduce((acc, cur) => ({
  ...acc,
  [cur.value]: {
    'type': 'raster',
    'tiles': [
      `https://www.ign.es/wms/pnoa-historico?service=WMS&request=GetMap&version=1.1.1&layers=PNOA${cur.value}&Style=default&Format=image/jpeg&srs=EPSG:3857&bbox={bbox-epsg-3857}&width=256&height=256`
    ],
    'tileSize': 256
  }
}), {});

export const PNOA_HISTORICO_BASEMAP = (year) => ({
  'version': 8,
  'name': 'PNOA',
  'glyphs': 'https://tileserver.geomatico.es/fonts/{fontstack}/{range}.pbf',
  'sources': PNOA_HISTORICO_SOURCES,
  'layers': [
    {
      'id': 'background',
      'type': 'background',
      'paint': {
        'background-color': '#F4F9F4'
      }
    },
    {
      'id': 'pnoa',
      'type': 'raster',
      'source': `${year}`,
      'maxzoom': 22
    }
  ]
});

export const PNOA_MIN = PNOA_YEARS.reduce(
  (accumulator, currentValue) =>
    accumulator.value < currentValue.value
      ? accumulator
      : currentValue
).value-1;

export const PNOA_MAX = PNOA_YEARS.reduce(
  (accumulator, currentValue) =>
    accumulator.value < currentValue.value
      ? currentValue
      : accumulator
).value+1;